module.exports = __webpack_public_path__ + "linea-software-10.8fe30102fca386ab297c.ttf";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-software-10.ttf
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-software-10.ttf
// module chunks = styles